import { createApi } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { AuthHeaders, baseQueryWithAuthInterceptor, decryptResponse } from "./util";
var qs = require('qs');

export const driversApi = createApi({
  reducerPath: "driversApi",
  baseQuery: baseQueryWithAuthInterceptor({ baseUrl: "/api/drivers" }),
  tagTypes: ["Driver"],
  endpoints: (builder) => ({
    getDrivers: builder.query({
      query: (body) => {
        let opts = {};
        if (body && body.forOrderId) {
          opts.params = { forOrderId: body.forOrderId };
        }
        if (body && body.metro) {
          opts.params = { metro: body.metro };
        } else if (body && body.status) {
          opts.params = { status: body.status };
        }
        else if (body && body.company) {
          opts.params = { ...opts.params, company: body.company }
        }
        if (body && body.status) {
          opts.params = { ...opts.params, status: body.status };
        }
        if (body && body.metro) {
          opts.params = { ...opts.params, metro: body.metro }
        }
        if (body && body.company) {
          opts.params = { ...opts.params, company: body.company }
        }
        return {
          url: "",
          ...opts,
        };
      },
      providesTags: ["Driver"],
    }),
    getInterestedDrivers: builder.query({
      query: (body) => {
        const opts = {};
        if (body && body.forOrderId) {
          opts.params = { forOrderId: body.forOrderId };
        }
        return {
          url: "get/interested",
          ...opts,
        };
      },
      providesTags: ["Driver"],
    }),
    getDriver: builder.query({
      query: (id) => id,
      providesTags: ["Driver"],
    }),

    updateDriver: builder.mutation({
      query: (body) => ({
        url: body._id,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    createOrUpdateCustomer: builder.mutation({
      query: (body) => ({
        url: `${body._id}/createOrUpdateCustomer`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) =>
        !result.error && [{ type: "Driver", _id: result._id }],
    }),
    createOrUpdateFundingSource: builder.mutation({
      query: (body) => ({
        url: `${body._id}/createOrUpdateFundingSource`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) =>
        !result.error && [{ type: "Driver", _id: result._id }],
    }),
    removeDriver: builder.mutation({
      query: (id) => ({
        url: id,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => !error && ["Driver"],
    }),
    waitListDriver: builder.mutation({
      query: (body) => ({
        url: `${body._id}/waiting`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    suspendDriver: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${id}/suspend`,
        method: "PUT",
        body
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    underReview: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${id}/underReview`,
        method: "PUT",
        body
      }),
      invalidatesTags: (result, error, arg) => !error && [{ type: "Driver", _id: result._id }],
    }),
    statusUnderReview: builder.mutation({
      query: (body) => ({
        url: `${body.id}/statusUnderReview`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, arg) => !error && [{ type: "Driver", _id: result._id }],
    }),
    removeUnderReview: builder.mutation({
      query: ({ id }) => ({
        url: `${id}/removeUnderReview`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    approveDriver: builder.mutation({
      query: (body) => ({
        url: `${body._id}/approve`,
        method: "PUT",
        body: { isConditionallyApproved: body.isConditionallyApproved || false },
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    rejectDriver: builder.mutation({
      query: (body) => ({
        url: `${body._id}/reject`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    blockDriver: builder.mutation({
      query: (body) => ({
        url: `${body._id}/block`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    unblockDriver: builder.mutation({
      query: (body) => ({
        url: `${body._id}/unblock`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    getAdhocPayment: builder.query({
      query: (body) => ({
        url: `get/adhocpayment/${body.day}`,
      }),
      providesTags: ["Driver"],
    }),
    getTransactionStatus: builder.mutation({
      query: (id) => ({
        url: `transactionStatus/${id}`,
        method: "POST",
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    paymentDriver: builder.mutation({
      query: (body) => ({
        url: `${body._id}/pay`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    createAccount: builder.mutation({
      query: (body) => ({
        url: `/createAccount`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) =>
        !result.error && [{ type: "Driver", _id: result._id }],
    }),
    getDirectPayee: builder.query({
      query: (body) => ({
        url: "get/directPayee",
      }),
      providesTags: ["Driver"],
    }),
    removeDirectpayee: builder.mutation({
      query: (id) => ({
        url: `${id}/directPayee`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => !error && ["Driver"],
    }),
    getSingleDirectPayment: builder.query({
      query: (id) => ({
        url: `${id}/directPayee`,
        method: "GET",
      }),
      providesTags: ["Driver"],
    }),
    getPayees: builder.query({
      query: (id) => ({
        url: `list/AdhocPayment`,
        method: "GET",
      }),
      providesTags: ["Driver"],
    }),
    approvePayment: builder.mutation({
      query: ({ _id, ...rest }) => ({
        url: `${_id}/approvePayment`,
        method: "POST",
        body: rest,
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    getApprovePaymentList: builder.query({
      query: (body) => ({
        url: `/get/approvedPaymentList?adhocPayments=${body?.adhocPayments}&instantPayments=${body?.instantPayments} &exceptionPayments=${body?.exceptionPayments} &weeklyPayments=${body?.weeklyPayments}&fromDate=${body?.fromDate || ""}&toDate=${body?.toDate || ""}${body?.isPaymentFail ? '&isPaymentFail=true' : ''}`,
        method: "GET",
      }),
      providesTags: ["Driver"],
    }),
    adhocPayment: builder.mutation({
      query: (body) => ({
        url: `${body._id}/payment`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    rejectDrivePayment: builder.mutation({
      query: (body) => ({
        url: `${body._id}/rejectPayment`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) =>
        !error && [{ type: "Driver", _id: result._id }],
    }),
    getDriversEarningReport: builder.query({
      query: (body) => {
        const opts = {};
        if (body) {
          opts.params = { fromDate: body.fromDate, toDate: body.toDate, paymentMode: body?.paymentMode !== null ? body?.paymentMode?.value : "" };
        }
        return {
          url: `/get/earnings`,
          ...opts,
          method: "GET",
        };
      },
      providesTags: ["Driver"],
    }),
    deleteDriver: builder.mutation({
      query: (body) => ({
        url: `${body?._id}`,
        method: "DELETE",
        body,
      }),
      invalidatesTags: (result, error, arg) => !error && ["Driver"],
    }),
    DriverInactive: builder.mutation({
      query: (body) => ({
        url: `${body?._id}/inactive`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, arg) => !error && ["Driver"],
    }),
    backgroundCheck: builder.mutation({
      query: (body) => ({
        url: `${body?._id}/checkrBackground`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) => !error && ["Driver"],
    }),
    getOneplusShift: builder.query({
      query: (body) => {
        const opts = {};
        if (body && body.forOrderId) {
          opts.params = { forOrderId: body.forOrderId };
        }
        if (body && body.metro) {
          opts.params = { metro: body.metro };
        } else if (body && body.status) {
          opts.params = { status: body.status };
        }
        else if (body && body.company) {
          opts.params = { company: body.company }
        }
        if (body && body.status) {
          opts.params = { ...opts.params, status: body.status };
        }
        if (body && body.company) {
          opts.params = { ...opts.params, company: body.company };
        }
        if (body && body.metro) {
          opts.params = { ...opts.params, metro: body.metro }
        }
        if (body && body.isMetroAll) {
          opts.params = { ...opts.params, isMetroAll: body.isMetroAll }
        }
        if (body && body.isCompanyAll) {
          opts.params = { ...opts.params, isCompanyAll: body.isCompanyAll }
        }

        if (body && ["reserved", "assigned", "delivery_started"].includes(body.status) && body.fromDate && body.toDate) {
          opts.params = { ...opts.params, fromDate: body.fromDate, toDate: body.toDate }
        }

        if (body && body.status && body.metro && body.fromDate && body.toDate) {
          opts.params = {
            ...opts.params,
            metro: body.metro,
            status: body.status,
            fromDate: body.fromDate,
            toDate: body.toDate,
          };
        }

        return {
          url: "/notifications/get",
          method: "GET",
          ...opts,
        };
      },
      providesTags: ["Driver"],
    }),
    Review: builder.mutation({
      query: (body) => ({
        url: `/verify/BackgroundChecks`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) => !error && ["Driver"],
    }),
    getDebugLicenceImg: builder.query({
      query: (id) => {
        return {
          // url: `${id}/debugLicense`,
          url: `${id}/getSignedLicenseUrl`,
          method: "GET",
        };
      },
      providesTags: ["Driver"],
    }),
    getDebugInsuranceImg: builder.query({
      query: (id) => {
        return {
          // url: `${id}/debugInsurance`,
          url: `${id}/getSignedInsuranceUrl`,
          method: "GET",
        };
      },
      providesTags: ["Driver"],
    }),
    getProfilePhoto: builder.query({
      query: (id) => {
        return {
          // url: `${id}/getSignedProfile`,
          url: `${id}/getSignedProfilePhotoUrl`,
          method: "GET",
        };
      },
      providesTags: ["Driver"],
    }),
    getSignedOAIUrl: builder.query({
      query: (id) => ({
        url: `${id}/getSignedOAIUrl`,
        method: "GET",
      }),
      providesTags: ["Driver"],
    }),
    removeDriverSignature: builder.mutation({
      query: (id) => ({
        url: `${id}/signature`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => {
        if (!error) {
          return ["Driver"];
        }
        return [];
      },
    }),
    refreshDriverBranch: builder.query({
      query: (id) => ({
        url: `/refresh-branch-details?id=${id}`,
        method: "GET",
      }),
      providesTags: ["Driver"],
    }),
    resetDocumentStatus: builder.mutation({
      query: ({id, ...body}) => ({
        url: `${id}/reset-document-status`,
        method: "POST",
        body
      }),
      invalidatesTags: (result, error, arg) => {
        if (!error) {
          return ["Driver"];
        }
        return [];
      },
    }),
    removeSsn: builder.mutation({
      query: (id) => ({
        url: `${id}/ssn`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => !error && ["Driver"],
    })
  }),
});

export const {
  useGetDriversQuery,
  useLazyGetInterestedDriversQuery,
  useLazyGetDriversQuery,
  useUpdateDriverMutation,
  useGetDriverQuery,
  useRemoveDriverMutation,
  useCreateOrUpdateCustomerMutation,
  useCreateOrUpdateFundingSourceMutation,
  useSuspendDriverMutation,
  useUnderReviewMutation,
  useStatusUnderReviewMutation,
  useRemoveUnderReviewMutation,
  useWaitListDriverMutation,
  useApproveDriverMutation,
  useRejectDriverMutation,
  useBlockDriverMutation,
  useUnblockDriverMutation,
  useGetAdhocPaymentQuery,
  useGetTransactionStatusMutation,
  usePaymentDriverMutation,
  useCreateAccountMutation,
  useGetDirectPayeeQuery,
  useRemoveDirectpayeeMutation,
  useGetSingleDirectPaymentQuery,
  useGetPayeesQuery,
  useApprovePaymentMutation,
  useGetApprovePaymentListQuery,
  useAdhocPaymentMutation,
  useRejectDrivePaymentMutation,
  useGetDriversEarningReportQuery,
  useDeleteDriverMutation,
  useDriverInactiveMutation,
  useBackgroundCheckMutation,
  useGetOneplusShiftQuery,
  useReviewMutation,
  useLazyGetDebugLicenceImgQuery,
  useLazyGetDebugInsuranceImgQuery,
  useLazyGetProfilePhotoQuery,
  useLazyGetSignedOAIUrlQuery,
  useRemoveDriverSignatureMutation,
  useResetDocumentStatusMutation,
  useLazyRefreshDriverBranchQuery,
  useRemoveSsnMutation,
} = driversApi;

export const getDriversList = async (
  page,
  limit,
  licenseStatusFilter,
  searchQuery,
  metro,
  shifFromDate,
  shifToDate,
  firstOrderDriver,
  isShiftCount,
  isBackgroundCheck,
  orderCountFrom,
  orderCountTo,
  scoreFrom,
  scoreTo,
  state,
  onboardingFrom,
  onboardingTo,
  registeredFrom,
  registeredTo,
  offboardedFrom,
  offboardedTo,
  intrestDriversFromDate,
  intrestDriversToDate,
  company,
  isNotSelected,
  daysData,
  timeData,
  timeAmount,
  onboardStatus,
  coaching,
  btReview,
  expiredFromDate,
  expiredToDate,
  expired,
  oaiInactive,
  isExport,
  branchStatus
) => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response = await axios.get(
      `/api/drivers?page=${page ? page : ""}&limit=${limit ? limit : ""
      }&search=${searchQuery}&shifFromDate=${shifFromDate}&shifToDate=${shifToDate}&registeredFrom=${registeredFrom}&registeredTo=${registeredTo}
      &firstOrderDriver=${firstOrderDriver}&isShiftCount=${isShiftCount}&orderCountFrom=${orderCountFrom}&orderCountTo=${orderCountTo}
      &scoreFrom=${scoreFrom}&scoreTo=${scoreTo}&isBackgroundCheck=${isBackgroundCheck}&onBoardFrom=${onboardingFrom}&onBoardTo=${onboardingTo}&offboardedFrom=${offboardedFrom}&offboardedTo=${offboardedTo}
      &InterestedFrom=${intrestDriversFromDate}&InterestedTo=${intrestDriversToDate}&isNotSelected=${isNotSelected}&isTotal=${true}&isCreated=${true}&oaiInactive=${oaiInactive}
      &timeAmount=${timeAmount?.id || ""}&onboardingStatus=${onboardStatus?.value || ""}&isCoaching=${coaching}&isbtReviewUnverified=${btReview}&expirationFromDate=${expiredFromDate}&expirationToDate=${expiredToDate}&isExpired=${expired}&isExport=${isExport}&timezone=${timezone}`,
      {
        'params': { 'metro': metro, "state": state, "status": licenseStatusFilter, "company": company, "availableDays": daysData, "availableTime": timeData, branchStatus },
        'paramsSerializer': function (params) {
          return qs.stringify(params, { arrayFormat: 'brackets' })
        },
        'headers': AuthHeaders()
      }
    );
    if (response.status === 200) {
      response.data = decryptResponse(response?.data);
      return response?.data;
    }
    else return "Something went wrong";
  } catch (e) {
    return e.response.data;
  }
};

export const getDriversMetrics = async (
  page,
  limit,
  licenseStatusFilter,
  searchQuery,
  metro,
  shifFromDate,
  shifToDate,
  firstOrderDriver,
  isShiftCount,
  isBackgroundCheck,
  orderCountFrom,
  orderCountTo,
  scoreFrom,
  scoreTo,
  state,
  onboardingFrom,
  onboardingTo,
  registeredFrom,
  registeredTo,
  offboardedFrom,
  offboardedTo,
  intrestDriversFromDate,
  intrestDriversToDate,
  company,
  isNotSelected,
  daysData,
  timeData,
  timeAmount,
  onboardStatus,
  coaching,
  btReview,
  expiredFromDate,
  expiredToDate,
  expired,
  oaiInactive,
  isExport,
  branchStatus
) => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await axios.get(
      `/api/drivers/driversMetrics?search=${searchQuery}&shifFromDate=${shifFromDate}&shifToDate=${shifToDate}&registeredFrom=${registeredFrom}&registeredTo=${registeredTo}
      &firstOrderDriver=${firstOrderDriver}&isShiftCount=${isShiftCount}&orderCountFrom=${orderCountFrom}&orderCountTo=${orderCountTo}
      &scoreFrom=${scoreFrom}&scoreTo=${scoreTo}&isBackgroundCheck=${isBackgroundCheck}&onBoardFrom=${onboardingFrom}&onBoardTo=${onboardingTo}&offboardedFrom=${offboardedFrom}&offboardedTo=${offboardedTo}
      &InterestedFrom=${intrestDriversFromDate}&InterestedTo=${intrestDriversToDate}&isNotSelected=${isNotSelected}&isTotal=${false}&isCreated=${true}&oaiInactive=${oaiInactive}
      &timeAmount=${timeAmount?.id || ""}&onboardingStatus=${onboardStatus?.value || ""}&isCoaching=${coaching}&isbtReviewUnverified=${btReview}&expirationFromDate=${expiredFromDate}&expirationToDate=${expiredToDate}&isExpired=${expired}&isExport=${false}&timezone=${timezone}`,
      {
        'params': { 'metro': metro, "state": state, "status": licenseStatusFilter, "company": company, "availableDays": daysData, "availableTime": timeData, branchStatus },
        'paramsSerializer': function (params) {
          return qs.stringify(params, { arrayFormat: 'brackets' })
        },
        'headers': AuthHeaders()
      }
    );
    if (response.status === 200) {
      response.data = decryptResponse(response?.data);
      return response?.data;
    }
    else return "Something went wrong";
  } catch (e) {
    return e.response.data;
  }
};

export const getApprovePaymentList = async (
  limit,
  page,
  searchQuery,
  PaymentMethod,
  adhocPayments,
  instantPayments,
  exceptionPayments,
  weeklyPayments,
  fromDate,
  toDate,
  isPaymentFail
) => {
  try {
    const response = await axios.get(
      `/api/drivers/get/approvedPaymentList?limit=${limit}&page=${page}&search=${searchQuery}&adhocPayments=${adhocPayments}&instantPayments=${instantPayments}&exceptionPayments=${exceptionPayments} &weeklyPayments=${weeklyPayments}&fromDate=${fromDate || ''}&toDate=${toDate || ''}${isPaymentFail ? '&isPaymentFail=true' : ''}&isTotal=${true}&paymentMode=${PaymentMethod?.value || ""}`,
      {
        'headers': AuthHeaders()
      }
    );
    if (response.status === 200) {
      response.data = decryptResponse(response?.data);
      return response?.data;
    } else return 'Something went wrong';
  } catch (e) {
    return e.response.data;
  }
};

export async function downloadTermPDF(payload) {
  try {
    const res = await axios.post(
      `/api/drivers/export-term-pdf`,
      payload, // Axios automatically serializes the payload object to JSON
      {
        headers: AuthHeaders(),
        responseType: 'blob', // Important: tells Axios to expect a binary response (like a PDF)
      }
    );

    // If responseType is 'blob', res.data will already be a Blob object
    const blob = res.data;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${payload.fileName}.pdf`; // You might want to get the filename from the Content-Disposition header if available
    document.body.appendChild(a); // Append to body to ensure it's clickable in all browsers
    a.click();
    document.body.removeChild(a); // Clean up the element
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading PDF:", error);
    // Handle error, e.g., show a notification to the user
    if (error.response && error.response.data instanceof Blob) {
      // If the error response is also a blob (e.g., an error PDF),
      // you might want to read it as text to get an error message.
      const errorText = await error.response.data.text();
      console.error("Server error message:", errorText);
      throw new Error(errorText);
    }
    throw error; // Re-throw the error for further handling
  }
}